<script lang="ts">
  import { get } from 'svelte/store'

  import {
    pageStore,
    fn,
    pageOptsStore,
  } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'
  import { Wallet } from '@packages/ui'
  import { configStore, providerStore, contractsStore } from '@src/stores'

  const { getBalance: getEvmBalance } = get(fn)
  let balance: string = ''

  const getBalance = async () => {
    try {
      balance = await getEvmBalance()
    } catch {
      balance = '0'
    }
  }

  $: $configStore.chainId && $providerStore && getBalance()

  let selected: string = '10'

  const goToPayment = () => {
    pageOptsStore.set({
      title: `Purchase stored value`,
      payments: {
        credenzaStoredValue: {
          disabled: true,
        },
      },
      tokens: [
        {
          contractAddress: $contractsStore.erc20Cred.address,
          amount: +selected,
        },
      ],
    })
    pageStore.set(Pages.PAYMENT)
  }
</script>

<Wallet
  bind:selected
  options={{
    title: `buy stored value`,
    description: `Buy/Send stored value for purchases throughout this website.`,
    onSendClick: () => pageStore.set(Pages.SEND_TOKENS),
    sendValueButtonText: `Send stored value`,
    isSendValueDisabled: !balance,
    onPaymentClick: goToPayment,
  }}
/>
